/**
 * 包装axios请求
 */
import axioss from "axios";
import qs from "qs";
import { getCookie, setCookie } from "./utils";
import jwtDecode from "jwt-decode";
import moment from "moment";
import apis from "@/common/api";

// 校验是否过期
function checkCookie() {
  let code = jwtDecode(getCookie(document.cookie, "access_token"));
  if (code.exp * 1000 - Date.parse(new Date()) < 8 * 60 * 1000) {
    // 如果剩余8分钟过期
    return false;
  }
  return true;
}

function axiosRequest(config) {
  let promise = new Promise((resolve, reject) => {
    config.headers = {
      Authorization: "Bearer " + getCookie(document.cookie, "access_token"),
      ...config.headers,
    };
    // config.params =
    //     qs.stringify(config.params, {
    //         encode: false
    //     })

    axioss(config)
      .then((response) => {
        if (Math.floor(response.status / 200) === 1) {
          resolve(response.data);
        } else {
          reject(response.error.message);
        }
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.data &&
          err.response.data.error &&
          err.response.data.error.message
        ) {
          reject(err.response.data.error.message);
        } else if (err.response.status === 401) {
          // 鉴权失败，重新回登录页
          // setCookie("userNum", "", -1);
          // setCookie("role", "", -1);
          // setCookie("access_token", "", -1);
          // window.location.href = "./index.html";
          window.location.href = "/#/login";
        } else {
          reject("请求失败");
        }
      });
  });
  return promise;
}

// 校验是否过期
async function getFreshTokens() {
  let refreshToken = getCookie(document.cookie, "refresh_token");
  await axiosRequest({
    method: "post",
    url: apis.login.api,
    data: qs.stringify({
      client_id: "webClient",
      grant_type: "refresh_token",
      client_secret: "MainsiteSecret",
      refresh_token: refreshToken,
    }),
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
  })
    .then((res) => {
      let d = new Date();
      d.setTime(d.getTime() + 0.5 * 24 * 60 * 60 * 1000);
      let expries = d.toUTCString();
      for (let item in res) {
        if (item === "access_token") {
          let code = jwtDecode(res[item]);
          expries = moment(code.exp * 1000).format();
        }
        document.cookie = `${item}=${res[item]};`; // 加入过期时间
        setCookie(item, res[item], expries);
      }
    })
    .catch((error) => {
      console.log("error", error);
      // this.$message({
      //     type: 'error',
      //     message: '请求失败'
      // });
    });
}

export function http(config) {
  // 先校验过期时间
  if (!config.nocheck) {
    let isValid = checkCookie();
    if (!isValid) {
      getFreshTokens();
      console.log("get refresh");
    }
  }
  return axiosRequest(config);
}
export function downloadFiles(url) {
  //下载文件
  let a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("download", "123");
  a.setAttribute("target", "_blank");
}

// 下载文件
export function downloadFile(url, datas, fileNameStr) {
  let request = axioss.create({
    responseType: "arraybuffer",
    paramsSerializer(params) {
      return qs.stringify(params, {
        encode: true,
      });
    },
  });

  request({
    method: "post",
    url: url,
    data: datas,
    headers: {
      Authorization: "Bearer " + getCookie(document.cookie, "access_token"),
    },
  })
    .then((res) => {
      let fileName = fileNameStr + ".csv" || "下载文件.csv";
      let blob = new Blob([res.data], {
        type: "text/csv;charset=utf-8",
      });
      let downloadElement = document.createElement("a");
      // 创建下载的链接
      let href = URL.createObjectURL(blob);
      downloadElement.href = href;

      fileName = decodeURI(fileName);
      // 下载后文件名
      downloadElement.download = fileName;
      document.body.appendChild(downloadElement);
      // 点击下载
      downloadElement.click();
      // 下载完成移除元素
      document.body.removeChild(downloadElement);
      // 释放掉blob对象
      URL.revokeObjectURL(href);
    })
    .catch((error) => {
      console.log(error);
    });
}
